import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PgFormField, PgFormLayout } from '../../../models/form.model';
import { DataService } from '../../../services/data.service';
import { LocalizationService } from '../../../services/localization.service';
import { NotificationsService } from '../../../services/notifications.service';
import { OptionMapsService } from '../../../services/option-maps.service';
import { AuthService } from '../../../services/auth.service';
import { SaveStatusService } from '../../../pg-ui-molecules/save-status.service';
import { EnvironmentService } from '../../../services/environment.service';
import { SingleFormComponent } from '../single-form-main';
import { PgTotemWidget } from '../../../models/totem.model';
import { PGUtilities } from '../../../utilities/pg-utilities';

@Component({
    selector: 'app-forms-totem-environment',
    templateUrl: './forms-totem-environment.component.html',
    styleUrls: ['./forms-totem-environment.component.scss'],
    standalone: false
})
export class FormsTotemEnvironmentComponent extends SingleFormComponent {

    resourceId = 'TotemEnvironment';

    constructor(protected dataService:DataService, protected authService:AuthService, protected localizationService:LocalizationService, protected router:Router, protected route:ActivatedRoute, protected notificationsService:NotificationsService, protected saveStatusService:SaveStatusService, protected optionMapsService:OptionMapsService, protected environmentService:EnvironmentService) {
        super(dataService, authService, localizationService, router, route, notificationsService, saveStatusService, optionMapsService, environmentService)
    }

    formLayout = new PgFormLayout([
        new PgFormField({ label: 'auto', type: 'string', name: 'pid', required: true }),
        new PgFormField({ label: 'auto', type: 'string', name: 'configuration', required: true, default: '-' }),
        new PgFormField({ label: 'auto', type: 'string', name: 'channel' }),
        new PgFormField({ label: 'auto', type: 'string', name: 'alternative_url' }),
        new PgFormField({ label: 'auto', type: 'select', name: 'realm_id' }),
        new PgFormField({ label: '', type: 'split', name: 'split' }),
        new PgFormField({ label: 'auto', type: 'string', name: 'data_name' }),
        new PgFormField({ label: 'auto', type: 'string', name: 'data_title', locale: true }),
        new PgFormField({ label: 'auto', type: 'select', name: 'data_type', required: true, options: [
            { value: 'host', text: 'Host' }, 
            { value: 'location', text: 'Location' }
        ] }),
        new PgFormField({ label: 'auto', type: 'select', name: 'data_linked', multi: true, options: [] }),
        new PgFormField({ label: 'auto', type: 'location', name: 'data_location', requiredIf: '$form.data_type == \'location\'' }),
        new PgFormField({ label: 'auto', type: 'file', fileType: 'images', name: 'data_logo' }),
        new PgFormField({ label: 'auto', type: 'file', fileType: 'images', name: 'data_background' }),
        new PgFormField({ label: 'auto', type: 'file', fileType: 'videos', name: 'data_splashScreen' }),
        new PgFormField({ label: 'auto', type: 'json', name: 'data_screenSaver' }),
        new PgFormField({ label: '', type: 'split', name: 'data_split' }),
        new PgFormField({ label: 'auto', type: 'boolean', name: 'data_disableChat' }),
        new PgFormField({ label: 'auto', type: 'string', name: 'data_whatsappChat' }),
        new PgFormField({ label: 'auto', type: 'split', name: 'data_header' }),
        new PgFormField({ label: 'auto', type: 'color', name: 'data_headerBackgroundColor' }),
        new PgFormField({ label: 'auto', type: 'color', name: 'data_headerTextColor' }),
        new PgFormField({ label: 'auto', type: 'file', fileType: 'images', name: 'data_headerLogo' }),
        new PgFormField({ label: 'auto', type: 'split', name: 'data_footer' }),
        new PgFormField({ label: 'auto', type: 'color', name: 'data_footerBackgroundColor' }),
        new PgFormField({ label: 'auto', type: 'color', name: 'data_footerTextColor' }),
        new PgFormField({ label: 'auto', type: 'file', fileType: 'images', name: 'data_footerLogo' }),
        new PgFormField({ label: 'auto', type: 'split', name: 'data_link' }),
        new PgFormField({ label: 'auto', type: 'string', name: 'data_linkUrl' }),
        new PgFormField({ label: 'auto', type: 'string', name: 'data_linkText' }),
        new PgFormField({ label: 'auto', type: 'object', name: 'data_widgets' }),
    ]);


    widgetModello:string = null;
    widgetList:Array<PgTotemWidget> = null;

    widgetExpanded:{ [id:string]: boolean } = {}

    widgetOptions:Array<{
        value: string
        text: string
        params: any
    }> = null;

    availableLanguages:Array<string> = null;

    protected afterInitializeForm() {
        return new Promise<void>((resolve, reject) => {
            this.availableLanguages = this.localizationService.availableApplicationLanguages;
            
            this.formLayout.getFieldByName('realm_id').default = this.authService.user.realm?.id;
            this.formLayout.getFieldByName('realm_id').visible = false;

            this.formLayout.getFieldByName('configuration').visible = false;

            this.widgetOptions = PgTotemWidget.widgetOptions

            let _selectOptions:any = {}

            for(let _field of this.formLayout.fieldList) {
                let _cleanFieldName = _field.name.replace(/@.*$/, '')

                if(_field.label == 'auto') _field.label = 'RESOURCES.TotemEnvironment.fields.' + _cleanFieldName + '.label';
                if(_field.tooltip == 'auto') _field.tooltip = 'RESOURCES.TotemEnvironment.fields.' + _cleanFieldName + '.tooltip';
                if(_field.placeholder == 'auto') _field.placeholder = 'RESOURCES.TotemEnvironment.fields.' + _cleanFieldName + '.placeholder';

                if(_field.type == 'select') {
                    if(_field.options == null) {
                        _field.options = _selectOptions[_field.name]
                    }

                    this.formLayout.getFieldLayout(_field.name).display = { oneLine: true }
                }
                else if(_field.type == 'html' || _field.type == 'location') {
                    this.formLayout.getFieldLayout(_field.name).display = { fullWidth: true }
                }
            }

            this.formLayout.getFieldByName('data_widgets').visible = false;
            this.formLayout.getFieldLayout('data_linked').condition = '$form.data_type == \'host\''

            this.formLayout.getFieldLayout('data_linkText').condition = '$form.data_linkUrl'

            this.formLayout.getFieldLayout('data_screenSaver').display = { fullWidth: true }

            this._loadConfigurations().then(() => {
                resolve()
            })
        })
    }

    configurationDataByModello:{ [modello:string]: any } = null;

    private _loadConfigurations() {
        return new Promise<void>((resolve, reject) => {
            this.dataService.getResourceData('Configuration', { limit: 1000,
                filter: [
                    { field: 'tipo', operator: '==', value: ['totem'] }
                ]}).subscribe((data) => {
                this.configurationDataByModello = {};

                for(let _item of data) {
                    if(_item.data != null && _item.modello != null) {
                        let _parsed = PGUtilities.tryParseJSON(_item.data);

                        this.configurationDataByModello[_item.modello] = _parsed;
                    }
                }

                this.dataService.getResourceData('TotemEnvironment', { limit: 1000 }).subscribe((data) => {

                    let _linkedOptions = []

                    for(let _item of data) {
                        if(_item.id != this.elementId && _item.published) {
                            let _parsed = PGUtilities.tryParseJSON(_item.data);
                            let _text = _parsed.title;
                      
                            if(_parsed.type == 'location') {
                                _linkedOptions.push({ value: _item.id, text: this.localizationService.getTranslatedValue(_text, true) })
                            }
                        }
                    }

                    this.formLayout.getFieldByName('data_linked').options = _linkedOptions

                    resolve();
                }, () => {
                    reject();
                })
            }, () => {
                reject();
            })
        })
    }

    protected adaptLoadData(values:any) {
        values = JSON.parse(JSON.stringify(values));

        if(values.data != null) {
            let _data = PGUtilities.tryParseJSON(values.data);
            delete values.data;

            for(let i in _data) {
                values['data_' + i] = _data[i];
            }
        }

        if(values.configuration == null) {
            values.configuration = '-'
        }

        if(values['data_widgets'] == null) {
            values['data_widgets'] = values.configuration == '-' ? [] : {}
        }

        if(values.configuration && values.configuration != '-') {
            let _config = this.configurationDataByModello[values.configuration]

            if(_config != null && _config.widgets != null) {
                let _widgets = []

                for(let _widget of _config.widgets) {
                    if(_widget.params == null) {
                        _widget.params = {}
                    }

                    let _values = values['data_widgets'][_widget.id];
        
                    if(_values != null) {
                        for(let i in _values) {
                            if(i != 'params') {
                                _widget[i] = _values[i];
                            }
                        }
                
                        if(_values.params != null) {    
                            for(let i in _values.params) {
                                _widget.params[i] = _values.params[i];
                            }
                        }
                    }

                    _widgets.push(new PgTotemWidget(_widget))
                }

                values['data_widgets'] = _widgets;
                
                for(let _prop of ['type','name','location','logo','background','screenSaver']) {
                    if(values['data_' + _prop] == null) {
                        values['data_' + _prop] = _config[_prop]
                    }
                }

                values.configuration = '-';
            }
        }
        else {
            let _widgets = []

            for(let _widget of values['data_widgets']) {
                _widgets.push(new PgTotemWidget(_widget))
            }

            values['data_widgets'] = _widgets;
        }

        return values;
    }

    protected async afterLoadData(values: any) {
        this.widgetModello = null;
        this.widgetList = values['data_widgets'];

        this.widgetExpanded = {}

        return values;
    }

    private _getDataVaulue(values:any) {
        let _data:any = {};

        let _dataFields = [];

        for(let i in values) {
            if(/^data_/.test(i)) {
                _dataFields.push(i)
            }
        }

        for(let _field of _dataFields) {
            _data[_field.replace(/^data_/, '')] = values[_field];
            delete values[_field];
        }

        return _data
    }

    protected adaptSaveData(values:any) {
        values = JSON.parse(JSON.stringify(values));

        values.data = JSON.stringify(this._getDataVaulue(values));

        return values;
    }

    onWidgetEditorValuesChange() {
        let _changes = { 'data_widgets': this.widgetList };

        this.formLayout.setData(_changes)
        this.onValueChange(_changes)
    }

    moveWidget(index:number, offset:number) {
        let _widget = this.widgetList.splice(index, 1)
        this.widgetList.splice(index + offset, 0, _widget[0])
        this.onWidgetEditorValuesChange()
    }

    deleteWidget(index:number) {
        this.widgetList.splice(index, 1)
        this.onWidgetEditorValuesChange()
    }

    addWidgetName:string = null;

    addWidget(name:string) {
        let _params = {};

        for(let _option of this.widgetOptions) {
            if(_option.value == name) {
                _params = _option.params
                break;
            }
        }

        let _widget = new PgTotemWidget({
            id: PGUtilities.getRandomId(),
            name: name,
            params: _params,
        })

        this.widgetList.push(_widget)
        this.onWidgetEditorValuesChange()
    }

    showJSON = false;

    JSONData = ''

    toggleShowJSON() {
        this.showJSON = !this.showJSON

        for(let _field of this.formLayout.fieldList) {
            if(_field.name != 'data_widget' && _field.name.startsWith('data_')) {
                this.formLayout.getFieldLayout(_field.name).hidden = this.showJSON;
            }
        }

        if(this.showJSON) {
            this.JSONData = JSON.stringify(this._getDataVaulue(this.formLayout.getData()))
        }
        else {
            let _data = PGUtilities.tryParseJSON(this.JSONData);

            let _values = {}

            for(let i in _data) {
                _values['data_' + i] = _data[i]
            }

            this.formLayout.setData(_values);

            this.widgetList = []

            for(let _widget of _values['data_widgets']) {
                this.widgetList.push(new PgTotemWidget(_widget))
            }
        }
    }

    getTranslatedValue(val:string) {
        return this.localizationService.getTranslatedValue(val, true)
    }
}

